export const DEFAULT_FORM_NAME = "advance_gu_agriculture";

const formNameOf = (form: any): string =>
  String(
    form?.LeadFormName ?? form?.name ?? form?.form_name ?? form?.label ?? "",
  )
    .trim()
    .toLowerCase();

export const getDefaultForm = <T = any>(
  forms: T[] | null | undefined,
): T | undefined => {
  if (!Array.isArray(forms) || forms.length === 0) return undefined;
  const preferred = forms.find(
    (form) => formNameOf(form) === DEFAULT_FORM_NAME,
  );
  return preferred ?? forms[0];
};
